export default [
  {
    type: 'selection',
    width: 55,
    show: true,
  },
  {
    title: '编号',
    key: 'id',
    minWidth: 40,
    maxWidth: 100,
    show: true,
  },
  {
    title: '活动名称',
    key: 'name',
    show: true,
  },
  {
    title: '开始时间',
    key: 'start_time',
    slot: 'start_time',
    show: true,
  },
  {
    title: '结束时间',
    key: 'end_time',
    slot: 'end_time',
    show: true,
  },
  {
    title: '状态',
    key: 'status',
    slot: 'status',
    show: true,
  },
  {
    title: '操作',
    key: 'action',
    slot: 'action',
    width: 120,
    align: 'center',
    fixed: 'right',
    show: true,
  },
]
